import './spinner.css';

interface SpinnerProps {
  width?: string;
  height?: string;
  active?: boolean;
}

export function Spinner({ width = '40px', height = '40px', active = true }: SpinnerProps) {
  if (!active) return null;
  return (
    <div className="sk-fading-circle" style={{ width, height }}>
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className={`sk-circle sk-circle-${i + 1}`} />
      ))}
    </div>
  );
}
